(() => {
  if (window.bmCardPreviewReady) return;
  window.bmCardPreviewReady = true;

  const setState = (button, playing) => {
    button.setAttribute('aria-pressed', String(playing));
    const title = button.getAttribute('data-bm-preview-title') || 'track';
    const label = button.getAttribute('data-bm-preview-label');
    button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${label ? label.toLowerCase() : 'preview'} of ${title}`);
    button.querySelector('.bm-card-preview__icon').textContent = playing ? 'Ⅱ' : '▶';
    button.querySelector('.bm-card-preview__text').textContent = playing ? 'Pause preview' : label || 'Preview track';
  };

  const updatePhone = (audio) => {
    const phone = audio.closest('.bm-phone');
    if (!phone || !audio.closest('.bm-phone__record')) return;
    const elapsed = Number.isFinite(audio.currentTime) ? audio.currentTime : 0;
    const duration = Number.isFinite(audio.duration) ? audio.duration : 0;
    const format = (seconds) => `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
    phone.querySelector('[data-bm-phone-progress]').value = duration ? elapsed / duration * 100 : 0;
    phone.querySelector('[data-bm-phone-elapsed]').textContent = format(elapsed);
    phone.querySelector('[data-bm-phone-duration]').textContent = duration ? format(duration) : '–:––';
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bm-preview-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const audio = button.parentElement.querySelector('[data-bm-preview-audio]');
    if (!audio) return;
    if (!audio.paused) {
      audio.pause();
      return;
    }

    document.querySelectorAll('[data-bm-preview-audio]').forEach((other) => {
      if (other !== audio) other.pause();
    });
    audio.play().catch(() => {
      setState(button, false);
      button.querySelector('.bm-card-preview__text').textContent = 'Preview unavailable';
    });
  });

  document.addEventListener('play', (event) => {
    if (event.target.matches?.('[data-bm-preview-audio]')) {
      const button = event.target.parentElement.querySelector('[data-bm-preview-button]');
      if (button) setState(button, true);
    }
  }, true);

  for (const name of ['pause', 'ended']) {
    document.addEventListener(name, (event) => {
      if (event.target.matches?.('[data-bm-preview-audio]')) {
        const button = event.target.parentElement.querySelector('[data-bm-preview-button]');
        if (button) setState(button, false);
      }
    }, true);
  }

  for (const name of ['loadedmetadata', 'timeupdate', 'ended']) {
    document.addEventListener(name, (event) => {
      if (event.target.matches?.('[data-bm-preview-audio]')) updatePhone(event.target);
    }, true);
  }
})();
